
import { Instagram } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const InstagramBanner = () => {
  const { t } = useTranslation();
  
  return (
    <section className="bg-gradient-to-r from-brand-yellow to-brand-yellow/80 py-12 text-brand-black">
      <div className="container">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h2 className="text-start text-2xl md:text-3xl font-bold mb-2">{t('instagram.title')}</h2>
            <p className="text-start text-lg opacity-90 max-w-xl">
              {t('instagram.subtitle')}
            </p>
          </div>
          <Button 
            size="lg" 
            className="bg-brand-black hover:bg-brand-black/90 text-brand-yellow flex items-center gap-2 px-6"
            asChild
          >
            <a 
              href="https://www.instagram.com/prebitit/" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Instagram className="h-5 w-5" />
              <span>@prebitit</span>
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default InstagramBanner;
